import { render, staticRenderFns } from "./UpgradePlanTooltip.vue?vue&type=template&id=36ea1054&scoped=true"
import script from "./UpgradePlanTooltip.vue?vue&type=script&lang=js"
export * from "./UpgradePlanTooltip.vue?vue&type=script&lang=js"
import style0 from "./UpgradePlanTooltip.vue?vue&type=style&index=0&id=36ea1054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea1054",
  null
  
)

export default component.exports